module.exports = __webpack_public_path__ + "img/security.4fea0874.png";